import axios from 'axios';
import { handleResponse, handleError } from './response';

axios.defaults.withCredentials = true;
const BASE_URL = process.env.REACT_APP_API_DOMAIN;

// axios.interceptors.request.use(req => {
//   console.log(`${req.method} ${req.url}`);
//   // req.headers.common.Lang = 'sss';
//   // Important: request interceptors **must** return the request.
//   return req;
// }, function (error) {
//   // Do something with request error
//   console.log(error);
//   return Promise.reject(error);
// });

// axios.interceptors.response.use(
//   res => res,
//   err => {
//     console.log(err); 
//     if (err.response.status === 401) {
//       // console.log('error');
//       throw new Error(`${err.config.url} not found`);
//     }
//     throw err;
//   }
// );

/** @param {string} resource */
const get = (resource) => {
    return axios
        .get(`${BASE_URL}/${resource}`)
        .then(handleResponse)
        .catch(handleError);
};

/** @param {string} resource */
/** @param {object} data */
const post = (resource, data) => {
    return axios
        .post(`${BASE_URL}/${resource}`, data)
        .then(handleResponse)
        .catch(handleError);
};

export const apiProvider = {
    get,
    post,
};